
import { Component, Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";


@Component({
    selector: 'app-no-payment-method-dialog',
    template: require('./noPaymentMethodDialog.html')
})
export class NoPaymentMethodDialogComponent {

    constructor(@Inject(MatDialogRef<NoPaymentMethodDialogComponent>) public dialogRef: MatDialogRef<NoPaymentMethodDialogComponent>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}

